import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
import AppChip from "@elements/AppChip.vue";
import { computed } from "vue";
import { useTranslation } from "i18next-vue";
import { canManageEventStaffFunctionsConf } from "@/utils/canManageEventStaffFunctionsConf";
import gql from "fraql";
const __default__ = {
    name: "AppShowEventStaffFunctionConfStatusChip",
    fragments: {
        eventFields: gql `
      fragment _ on Event {
        allowedMutations
      }
    `,
        confFields: gql `
      fragment _ on EventStaffFunctionsConf {
        visibility
        recruitmentComplete
        personEventStaffFunctionsUnlisted
        allowedMutations
      }
    `
    }
};
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        event: {},
        conf: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useTranslation();
        const canManageSoCanViewUnlistedStatus = computed(() => {
            return (canManageEventStaffFunctionsConf(props.event, props.conf) &&
                props.conf.personEventStaffFunctionsUnlisted);
        });
        const statusChip = computed(() => {
            switch (props.conf.visibility) {
                case "public":
                    return {
                        color: "text-green",
                        text: t("events:eventProfilePage.eventStaffFunctionsConf.visibilityChip.public.label", "Public")
                    };
                case "admins":
                default: {
                    return {
                        color: "text-black",
                        text: t("events:eventProfilePage.eventStaffFunctionsConf.visibilityChip.admins.label", "Internal")
                    };
                }
            }
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            return (_openBlock(), _createBlock(_component_v_tooltip, {
                location: "bottom",
                disabled: !_ctx.conf.recruitmentComplete && !canManageSoCanViewUnlistedStatus.value
            }, {
                activator: _withCtx(({ props: attrs }) => [
                    _createVNode(AppChip, _mergeProps({
                        "text-color": statusChip.value.color,
                        class: "bg-white",
                        variant: "outlined"
                    }, { ..._ctx.$attrs, ...attrs }), {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(statusChip.value.text), 1),
                            (canManageSoCanViewUnlistedStatus.value)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    end: "",
                                    color: "black",
                                    size: "x-small",
                                    icon: "$iconEyeSlash"
                                }))
                                : _createCommentVNode("", true),
                            (_ctx.conf.recruitmentComplete)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    end: "",
                                    color: "black",
                                    size: "x-small",
                                    icon: "$iconLock"
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _: 2
                    }, 1040, ["text-color"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("span", null, [
                        (canManageSoCanViewUnlistedStatus.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("events:eventProfilePage.eventStaffFunctionsConf.visibilityChip.candidatesUnlisted.tooltip", "Candidates list is hidden")), 1)
                            ], 64))
                            : _createCommentVNode("", true),
                        (canManageSoCanViewUnlistedStatus.value && _ctx.conf.recruitmentComplete)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" | ")
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.conf.recruitmentComplete)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("events:eventProfilePage.eventStaffFunctionsConf.visibilityChip.recruitmentComplete.tooltip", "recruitment complete")), 1)
                            ], 64))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 8, ["disabled"]));
        };
    }
});
